@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.profile.log_water.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.profile.log_water.generated.resources/"

@delegate:ResourceContentHash(218_863_635)
internal val Res.drawable.ic_bottle: DrawableResource by lazy {
      DrawableResource("drawable:ic_bottle", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_bottle.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-914_838_361)
internal val Res.drawable.ic_minus: DrawableResource by lazy {
      DrawableResource("drawable:ic_minus", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_minus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_806_171_250)
internal val Res.drawable.ic_plus: DrawableResource by lazy {
      DrawableResource("drawable:ic_plus", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_plus.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(279_049_630)
internal val Res.drawable.img_water_footer: DrawableResource by lazy {
      DrawableResource("drawable:img_water_footer", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/img_water_footer.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/img_water_footer.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/img_water_footer.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_bottle", Res.drawable.ic_bottle)
  map.put("ic_minus", Res.drawable.ic_minus)
  map.put("ic_plus", Res.drawable.ic_plus)
  map.put("img_water_footer", Res.drawable.img_water_footer)
}
